import { PageHeader } from "@/widgets/page-header"
import { PageSubtitle } from "@/shared/ui/page-subtitle"
import { useEffect } from "react"
import { useAppDispatch, useAppSelector } from "@/shared/lib/redux"
import { fetchEmployeesInvitations, selectEmployeesInvitations, selectEmployeesInvitationsFirstLoad, selectEmployeesInvitationsLoading } from "@/entities/invitation"
import { CreateInvitation } from "@/entities/invitation/ui/create-invitation"
import { InvitationsTable } from "@/entities/invitation/ui/invitations-table"

export const EmployeesInvitationsPage = () => {
    const invitationsFirstLoad = useAppSelector(selectEmployeesInvitationsFirstLoad)
    const dispatch = useAppDispatch()
    const invitations = useAppSelector(selectEmployeesInvitations)
    const isLoading = useAppSelector(selectEmployeesInvitationsLoading)
    
    useEffect(() => {
        if (invitationsFirstLoad) {
            dispatch(fetchEmployeesInvitations())
        }
    }, [])

    return (
        <div className="_page_container">
            <PageHeader title="сотрудники" />
            <div className="flexbox">
                <PageSubtitle title="Приглашения" />
                <div className="w-full flex justify-end gap-2">
                    <div className="w-full bg-white h-[52px] rounded-full block"/>
                    <CreateInvitation onCreate={() => dispatch(fetchEmployeesInvitations())} role="employees"/>
                </div>
                <InvitationsTable isLoading={isLoading} invitations={invitations} onDelete={() => dispatch(fetchEmployeesInvitations())} />
            </div>
        </div>
    )
}